// extracted by mini-css-extract-plugin
export default {"inputPasswordSection":"style_inputPasswordSection__bCvyV","focus":"style_focus__3WSrm","input":"style_input__gQGIf","icon":"style_icon__MhXgr"};